import React, { useState } from 'react';
import { FieldArray } from 'formik';
import { GridColumnTitle, Label } from '../Form/';

import {
  Container,
  TableHeader,
  TableColumn,
  InlineLabel,
  TableHead,
  TableRow,
  TableBody,
  Table,
  CustomField
} from './styles';
import Icon from "../Icon";


const ResponsiveTable = ({ 
  columns = [], 
  data = [], 
  changeRemoveAttachments, 
  changeShowAttachments,
  formikRef,
  defaultEmptyValue = '-',
  onSortTable,
  showRow,
  showEndorsement,
  showChildren,
  childrenKey,
  showRowWorkflow,
  withHorizontalScroll,
  height,
}) => {
  const [orderArrows, setOrderArrows] = useState({});

  const removeAttachment = value => {
    let elementToRemove, newAttachments;

    elementToRemove = data.find((att, index) => att.id === value.id);
    newAttachments = data.filter(attachment => attachment.id !== elementToRemove.id);

    changeRemoveAttachments(newAttachments);
  }

  function resetFormikOrderParams(formikRef) {
    columns.map(column => formikRef.setFieldValue(column.sortKey, null))
  }

  const renderRow = (row, indexData, isChildRow) => {
    return <TableRow key={indexData} style={row.highlightPayment === true ? {backgroundColor: '#BBBBBB'} : {}}>
      {columns.map((column, index) => {
        const keys = column.key?.split('|') || [];
        return <TableColumn key={index}>
          <InlineLabel>
            {column.title}
          </InlineLabel>
          {column.component && <CustomField>
            {column.component(row, indexData, isChildRow)}
          </CustomField>}
          {!column.component && <Label wordWrap fontSize={13} color={column.color ? column.color(row) : null}>
            {row[keys[0]] || row[keys[1]] || '-'}
          </Label>}
          {changeShowAttachments && (
            changeRemoveAttachments && column.key === 'remove' && <Label wordWrap fontSize={12}>
              <Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => removeAttachment(row)} />
            </Label>)}
        </TableColumn>
      })}
    </TableRow>
  }

  const renderChildrenRow = (dataChildren, data, isEndorsement=false) => {

    if (isEndorsement) {
      for (let i = 0; i < dataChildren.length; i++) {
        dataChildren[i].sompoBroker = data?.sompoBroker;
        dataChildren[i].modality = data?.modality || data?.modalityPrivateSector;
        dataChildren[i].borrower = data?.borrower;
        dataChildren[i].insured = data?.insured;
      }
    }

    return (
      <FieldArray
        name="tableData"
        render={() =>
          dataChildren.map((row, index) => (
            <TableRow key={index}>
            {columns.map((column, index) => {
              const keys = column.key?.split('|') || [];
              return (
              <TableColumn key={index}>
                      <InlineLabel>
                        {column.title}
                      </InlineLabel>
                      {column.component && <CustomField  endorsementPaddingLeft={true}>
                        {column.component(row)}
                      </CustomField>}
                      {!column.component && <Label wordWrap fontSize={13} color={column.color ? column.color(row) : null}>
                        {row[keys[0]] || row[keys[1]] || defaultEmptyValue}
                      </Label>}
              </TableColumn>
              )
            })}
          </TableRow>
          ))
        }
      />
    )
  }

  return (
    <Container withHorizontalScroll={withHorizontalScroll} height={height} style={{ marginLeft: 15, marginRight: 15 }}>
      <Table withHorizontalScroll={withHorizontalScroll}>
        <TableHead>
          <TableRow>
            {columns.map((column, index) =>
              <TableHeader 
                key={index} 
                minWidth={column.minWidth} 
                minWidthInPixel={column.minWidthInPixel}
                maxWidth={column.maxWidth} 
                paddingRight={column.paddingRight}
                notLastColumnAlign={column.notLastColumnAlign}
              >
                <GridColumnTitle
                  style={{ cursor: column.sortKey ? "pointer" : 'not-allowed' }}
                  onMouseOut={() => setOrderArrows({ ...orderArrows, [column.sortKey]: false })}
                  onMouseOver={() => setOrderArrows({ ...orderArrows, [column.sortKey]: true })}
                  onClick={() => {
                    if (!column.sortKey) return;

                    const orderType = formikRef?.values[column.sortKey] == 2 ? 0 : (formikRef?.values[column.sortKey] || 0) + 1;
                    resetFormikOrderParams(formikRef);
                    formikRef.setFieldValue(column.sortKey, orderType);
                    onSortTable(column.sortKey, orderType);
                  }}
                >
                  {!changeShowAttachments && column.title === 'Remove' ? '' : column.title && column.title.toUpperCase()}
                  {" "}
                  {(
                    !formikRef?.values || !formikRef?.values[column.sortKey] || !column.sortKey
                      ? (<></>)
                      : (<Icon name={formikRef?.values[column.sortKey] == 2
                        ? "arrowdown"
                        : "arrowup"} />)
                  )}
                </GridColumnTitle>
              </TableHeader>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <FieldArray
            name="tableData"
            render={() =>
              data.map((row, index) => (
                <>
                <TableRow key={index}>
                  {columns.map((column, i) => {
                    const keys = column.key?.split('|') || [];
                    return <TableColumn key={i}>
                      <InlineLabel>
                        {column.title}
                      </InlineLabel>
                      {
                      column.component && <CustomField>
                        {column.component(row, index)}
                      </CustomField>
                      }
                      {
                        !column.component && <Label
                          wordWrap
                          fontSize={13}
                          color={column.color
                            ? column.color(row)
                            : null}
                        >
                          {row[keys[0]] || row[keys[1]] || defaultEmptyValue}
                        </Label>
                      }
                      {changeShowAttachments && (
                        changeRemoveAttachments && column.key === 'remove' && <Label wordWrap fontSize={12}>
                          <Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => removeAttachment(row)} />
                        </Label>
                      )}
                    </TableColumn>
                  })}
                </TableRow>
                 {row.endorsements && row.endorsements.length > 0 && showEndorsement.includes(row.idOperation) && renderChildrenRow(row.endorsements, data[index], true)}
                 {row[childrenKey] && row[childrenKey].length > 0 && showChildren.includes(index) && renderChildrenRow(row[childrenKey], data[index])}
                 {showRow && showRow(row.idOperation)}
                 {showRowWorkflow && showRowWorkflow(row.idQuestion)}
                </>
              ))
            }
          />
        </TableBody>
      </Table>
    </Container>
  );
};


export default ResponsiveTable;
